<template>
    <div>
        <v-server-table ref="disciplinaryTable" url="/employees/disciplinary-actions/list" :columns="columns" :options="options">

            <router-link slot="disc_action_id" slot-scope="props" :to="`/employees/disciplinary-actions/view/${props.row.disc_action_id}`" class="btn btn-sm btn-secondary" title="View Disciplinary Action">
                View - {{ props.row.disc_action_id }}
            </router-link>

            <router-link slot="violation_name" slot-scope="props" :to="`/employees/disciplinary-actions/view/${props.row.disc_action_id}`" title="View Disciplinary Action">
                <template v-if="props.row.disc_violation_id">
                    {{ props.row.violation_name }}
                </template>
                <template v-else>
                    {{ props.row.other_violation_name }}
                </template>
            </router-link>

            <template slot="penalty_name" slot-scope="props">
                <template v-if="props.row.disc_violation_id">
                    {{ props.row.penalty_name }}
                </template>
                <template v-else>
                    {{ props.row.other_penalty_name }}
                </template>
            </template>

            <template slot="bonus_disqual_time" slot-scope="props">
                <template v-if="props.row.disc_violation_id">
                    {{ props.row.bonus_disqual_time }}
                </template>
                <template v-else>
                    {{ props.row.other_bonus_disqual_time }}
                </template>
            </template>

            <router-link slot="employee_last_name" slot-scope="props" :to="`/employees/view/${props.row.employee_id}`" title="View Employee">
                {{ props.row.employee_first_name }} {{ props.row.employee_last_name }}
            </router-link>

            <template slot="supervisor_last_name" slot-scope="props">
                <user-name :user="supervisor(props.row)" />
            </template>

            <template slot="disc_action_date" slot-scope="props">
                {{ props.row.disc_action_date | moment("MM/DD/YYYY") }}
            </template>

            <template slot="JobsiteName" slot-scope="props">
                {{ props.row.JobsiteNumber }} - {{ props.row.JobsiteName }}
            </template>

            <template slot="email_ack_at" slot-scope="props">
                {{ props.row.email_ack_at | moment("MM/DD/YYYY") }}
            </template>

            <template slot="child_row" slot-scope="props">
                <span class="font-weight-bold">Violation Detail</span><br>
                <div v-html="props.row.violation_detail"></div>
            </template>

        </v-server-table>
    </div>
</template>

<script>
    export default {
        props: ['timeFilter'],

        data: function() {
            return {
                columns: ['disc_action_id', 'violation_name', 'penalty_name', 'bonus_disqual_time', 'supervisor_last_name', 'employee_last_name', 'disc_action_date', 'JobsiteName', 'email_ack_at'],
                options: {
                    headings: {
                        disc_action_id: 'ID',
                        violation_name: 'Violation',
                        penalty_name: 'Penalty',
                        bonus_disqual_time: 'Bonus Disqual.',
                        supervisor_last_name: 'Supervisor',
                        employee_last_name: 'Employee',
                        disc_action_date: 'Date',
                        JobsiteName: 'Jobsite',
                        email_ack_at: 'Acknowledgement'
                    },
                    orderBy: {
                        ascending: true,
                        column: 'disciplinary_actions.disc_action_id',
                    },
                    responseAdapter: (response) => {
                        //Emit the count
                        this.$emit('disciplinaryListCount', response.data.count);

                        //Send it
                        return response.data;
                    },
                    requestAdapter: (data) => {
                        data.filters = {
                            'disciplinary_actions.disc_action_date': this.timeFilter.toLowerCase(),
                        };

                        this.getPreviousData();

                        return data;
                    },
                    uniqueKey: 'disc_action_id',
                },
            }
        },

        methods: {
            supervisor: function(row) {
                return {
                    FirstName: row.supervisor_first_name,
                    LastName: row.supervisor_last_name,
                    deleted_at: row.supervisor_deleted_at,
                };
            },

            getPreviousData: function() {
                this.$http.get('/employees/disciplinary-actions/list', {'filters': {'disciplinary_actions.disc_action_date': 'prev_'+this.timeFilter.toLowerCase()}})
                    .then(response => {
                        this.$emit('prevDisciplinaryListCount', response.data.count);
                    })
                    .catch(err => {

                    })
                    .then(() => {

                    });
            },
        },
    }
</script>
